// static
export * from "./theme-announcement";
export * from "./theme-header";
export * from "./theme-footer";
export * from "./theme-store-locator";
export * from "./theme-product-recent";
export * from "./theme-product-recommended";
export * from "./theme-product-results";
export * from "./theme-error";
export * from "./theme-usp";
export * from "./theme-instagram";
export * from "./theme-geo-redirection-popup";

// dynamic
export * from "./dynamic-artist-layout";
export * from "./dynamic-beauty-in-making";
export * from "./dynamic-collection";
export * from "./dynamic-collection-footer";
export * from "./dynamic-competition";
export * from "./dynamic-products";
export * from "./dynamic-cta";
export * from "./dynamic-hero";
export * from "./dynamic-page-title";
export * from "./dynamic-content-contact";
export * from "./dynamic-hero-alt";
export * from "./dynamic-shop-the-look";
export * from "./dynamic-image-title";
export * from "./dynamic-image-content";
export * from "./dynamic-image-grid";
export * from "./dynamic-collection-grid";
export * from "./dynamic-image-layers";
export * from "./dynamic-image-text";
export * from "./dynamic-image-with-text-slider";
export * from "./dynamic-stack-image";
export * from "./dynamic-static-image";
export * from "./dynamic-fourty-anniversary";
export * from "./dynamic-featured-content";
export * from "./dynamic-featured-content-enhanced";
export * from "./dynamic-featured-titles";
export * from "./dynamic-double-image";
export * from "./dynamic-single-line-cta";
export * from "./dynamic-richtext";
export * from "./dynamic-featured-collection";
export * from "./dynamic-nav-anchor";
export * from "./dynamic-accordion-list";
export * from "./dynamic-care-image-with-cta";
export * from "./dynamic-material-image-with-description";
export * from "./dynamic-mini-hero";
export * from "./dynamic-tabs-block";
export * from "./dynamic-text-banner";
export * from "./dynamic-text-block";
export * from "./dynamic-video";
export * from "./dynamic-instagram";
export * from "./dynamic-goals-content";
export * from "./dynamic-featured-image-grid";
export * from "./dynamic-wool-traceability-animation";
export * from "./dynamic-padding";
export * from "./dynamic-anchor";
export * from "./dynamic-klaviyo-form";
export * from "./dynamic-custom-code";
